(function () {
  var idleDone = false;
  var interactionDone = false;
  var IDLE_MS = 4500;
  /* Chat widget (Podium): load only after a real user interaction, never on the idle
     timer. Its CSS + web-font chain is large and, when injected on idle, dominates the
     initial-load critical path on mobile. Real users still get chat on first tap/scroll. */
  var INTERACTION_ONLY = /connect\.podium\.com/i;

  function activate(placeholder) {
    var src = placeholder.getAttribute('data-deferred-script');
    if (!src) return;

    var s = document.createElement('script');
    s.src = src;

    if (placeholder.hasAttribute('data-deferred-module')) {
      s.type = 'module';
      if (placeholder.hasAttribute('data-deferred-crossorigin')) {
        s.crossOrigin = 'anonymous';
      }
    }

    Array.prototype.forEach.call(placeholder.attributes, function (attr) {
      if (
        attr.name === 'type' ||
        attr.name === 'data-deferred-script' ||
        attr.name === 'src' ||
        attr.name === 'data-deferred-module' ||
        attr.name === 'data-deferred-crossorigin'
      ) {
        return;
      }
      if (attr.name.indexOf('data-deferred') === 0) return;
      if (attr.name.indexOf('data-easify') === 0) return;
      try {
        s.setAttribute(attr.name, attr.value);
      } catch (e) {}
    });

    if (placeholder.hasAttribute('data-async')) s.async = true;
    if (placeholder.hasAttribute('data-defer')) s.defer = true;

    if (placeholder.hasAttribute('data-init-acsb')) {
      s.onload = function () {
        if (window.acsbJS && typeof window.acsbJS.init === 'function') {
          window.acsbJS.init();
        }
      };
    }

    (document.head || document.body).appendChild(s);
    placeholder.remove();
  }

  function restoreEasifyCss() {
    document.querySelectorAll('link[data-easify-css-href]').forEach(function (link) {
      var href = link.getAttribute('data-easify-css-href');
      if (!href) return;
      link.setAttribute('href', href);
      link.removeAttribute('data-easify-css-href');
      link.media = 'all';
      link.disabled = false;
    });
  }

  function loadEasifyDeferredScripts() {
    restoreEasifyCss();
    document.querySelectorAll('script[data-easify-deferred][data-deferred-script]').forEach(activate);
  }

  function loadDeferredScripts(includeInteractionOnly) {
    document.querySelectorAll('script[data-deferred-script]').forEach(function (placeholder) {
      /* Keep Easify off Home/PLP until quick-add explicitly asks for it. */
      if (placeholder.hasAttribute('data-easify-deferred')) return;
      if (!includeInteractionOnly && INTERACTION_ONLY.test(placeholder.getAttribute('data-deferred-script') || '')) {
        return;
      }
      activate(placeholder);
    });
  }

  /* Real interaction (or a programmatic call) loads everything, including chat. */
  function loadAllDeferredScripts() {
    if (interactionDone) return;
    interactionDone = true;
    idleDone = true;
    loadDeferredScripts(true);
  }

  /* Idle timer loads everything except interaction-only widgets (chat). */
  function loadIdleDeferredScripts() {
    if (idleDone) return;
    idleDone = true;
    loadDeferredScripts(false);
  }

  window.loadDeferredEasifyScripts = loadEasifyDeferredScripts;
  window.loadDeferredThirdPartyScripts = loadAllDeferredScripts;

  ['pointerdown', 'keydown', 'touchstart', 'scroll'].forEach(function (eventName) {
    window.addEventListener(eventName, loadAllDeferredScripts, { once: true, passive: true });
  });

  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadIdleDeferredScripts, { timeout: IDLE_MS });
  } else {
    setTimeout(loadIdleDeferredScripts, IDLE_MS);
  }
})();
